<app-main-layout class="signup-page">
  <app-signup-form class="signup-form"></app-signup-form>
</app-main-layout>
